<template>
    <div class="btcdirect-widget-container" :class="configurationStore.mode">
        <template v-if="authenticationStore.client.initialized">
            <template v-if="authenticationStore.client.authenticated">
                <slot />
            </template>

            <invalid-client-token v-if="!authenticationStore.client.authenticated" />
        </template>
    </div>
</template>

<script lang="ts" setup>
import { useClientAuthentication, useTranslations } from '@btcdirect/composables';
import { useSystemInfo } from '@btcdirect/shared/src/composables/api/system/system-info';
import { useLogger } from '@btcdirect/shared/src/composables/util/logger';
import { useAuthenticationStore, useConfigurationStore } from '@btcdirect/stores';
import 'out-of-the-vue/dist/out-of-the-vue.css';
import { onMounted } from 'vue';
import InvalidClientToken from '../notification/invalid-client-token.vue';

const authenticationStore = useAuthenticationStore();
const configurationStore = useConfigurationStore();

const { warn } = useLogger();
const { authenticate } = useClientAuthentication();
const { addTranslationDomain } = useTranslations();

onMounted(async () => {
    try {
        addTranslationDomain('widgets-generic');

        await authenticate();
        // TODO: Loader triggers getting the system info to set the locale. This should be done here instead.
        useSystemInfo();
    } catch (error) {
        warn('Failed to authenticate client or fetch system info', error);
    }
});
</script>

<style lang="scss">
@use '@@scss/generic/embeddable';
@use '@@scss/generic/out-of-the-vue';
@use '@@scss/variables';

.btcdirect-widget {
    &-container {
        height: 100%;
        max-height: variables.$widget-max-height;
        min-height: variables.$widget-min-height;
        overflow: hidden;
        position: relative;
        width: clamp(variables.$widget-min-width, 100%, variables.$widget-max-width);
    }

    .dark-mode {
        .list-select-item,
        .payment-methods-grid,
        .btcdirect-radio-group-item {
            .icon-applepay,
            .icon-XLM,
            .icon-NEAR {
                filter: invert(1);
            }
        }
        .order__field--payment-method {
            .icon-visa {
                filter: brightness(8);
            }
        }
    }
}
</style>
